import React from 'react';
import { Routes, Route } from 'react-router';

import { EpicsStoriesList, JiraItemsPage } from '../projects';
import { TestSuitesList } from '../test-suites';
import ProjectTestPlan from '../projects/ProjectTestPlan';
import TestProfileData from '../projects/TestProfileData';
import RequirementUploadPage from '../projects/RequirementUploadPage';
import ProjectCrawlPage from '../projects/crawl/ProjectCrawlPage';
import NotFound from '../../pages/NotFound';
import {
  TestCasesPage,
  TestCaseDetailPage,
  TestSuitesPage,
  SuiteDetailPage,
  TestPlansPage,
  PlanDetailPage,
  ExecutionsHub,
  ExecutionDetailPage,
  RequirementsHub,
  TestIntelligencePage,
  ReportsPage,
  SettingsScoped,
  ProjectsWorkspace,
  SchedulesWorkspace,
  EnvironmentsWorkspace,
  TestDataWorkspace,
  WorkspacesPage,
  EnvironmentFormPage,
} from '../rt2';

const DashboardRoutes = ({
  dashboardHome,
  navigateTo,
  handleViewProjectTestSuites,
  selectedTestSuite,
  fetchAllData,
  location
}) => {
  return (
    <Routes>
      <Route index element={dashboardHome} />
      <Route path="overview" element={dashboardHome} />

      <Route
        path="projects"
        element={<ProjectsWorkspace />}
      />

      {/* DEFINE */}
      <Route path="requirements" element={<RequirementsHub initialTab="requirements" />} />
      <Route path="requirements/epics" element={<RequirementsHub initialTab="epics" />} />
      <Route path="requirements/jira" element={<RequirementsHub initialTab="jira" />} />
      <Route path="jira-items/:idAndName" element={<JiraItemsPage />} />
      <Route path="epics-stories-list" element={<EpicsStoriesList />} />
      <Route path="project-requirement-upload/:project_id" element={<RequirementUploadPage />} />

      {/* BUILD */}
      <Route path="test-suites" element={<TestSuitesPage />} />
      <Route
        path="test-suites/details"
        element={
          <TestSuitesList
            projectId={new URLSearchParams(location.search).get('project_id')}
            onBack={() => navigateTo('test-suites')}
            selectedTestSuite={selectedTestSuite}
          />
        }
      />
      <Route path="test-suites/:suiteId" element={<SuiteDetailPage />} />
      <Route path="test-cases" element={<TestCasesPage />} />
      <Route path="test-cases/:testCaseId" element={<TestCaseDetailPage />} />
      <Route path="test-plans" element={<TestPlansPage />} />
      <Route path="test-plans/:planId" element={<PlanDetailPage />} />

      {/* RUN */}
      <Route path="executions" element={<ExecutionsHub />} />
      <Route path="executions/:executionId" element={<ExecutionDetailPage />} />
      <Route path="schedules" element={<SchedulesWorkspace />} />
      <Route path="schedule-plan-list" element={<SchedulesWorkspace />} />

      {/* ANALYZE */}
      <Route path="reports" element={<ReportsPage />} />
      <Route path="intelligence" element={<TestIntelligencePage />} />
      <Route path="learning" element={<TestIntelligencePage />} />

      {/* CONFIGURE */}
      <Route path="project-environment-list/:project_id" element={<EnvironmentsWorkspace />} />
      <Route path="project-environment/:project_id" element={<EnvironmentFormPage />} />
      <Route path="test-data-list/:project_id" element={<TestDataWorkspace />} />
      <Route path="project-crawl/:project_id" element={<ProjectCrawlPage />} />
      <Route path="/project-test-plan/:project_id" element={<ProjectTestPlan />} />
      <Route path="/project-test-data/:project_id" element={<TestProfileData />} />

      <Route path="all-workspaces" element={<WorkspacesPage />} />
      <Route path="settings" element={<SettingsScoped />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default DashboardRoutes;
